export default __webpack_public_path__ + "static/media/ponentes__Joao Resende.22a12771.jpg";